<div class="container-right-main fluid-container">
    <app-feedback-header [feedback]="feedback" [buttonText]="'Show Conversation'" (backClick)="goBack()"
        (showConversationClick)="viewFeedbackConversation()" (assignClick)="openAssignTicketToDialog()">
    </app-feedback-header>

    <app-feedback-comment-timeline #timelineRef [feedbackId]="feedbackId" [downloadContext]="'feedback'"
        [historyDetails]="historyDetails" [feedbackStatusList]="feedbackStatusList"
        [selectedFeedbackStatus]="selectedFeedbackStatus" [commentText]="commentText" [isSubmitting]="isSubmitting"
        [isLoading]="isLoading" (statusChange)="onFeedbackStatusChange($event)" (submitComment)="addComment()"
        (openEvaluationDialog)="openEvaluationDialog($event)" (commentTextChange)="commentText = $event"
        (filesChanged)="onFilesChanged($event)">
    </app-feedback-comment-timeline>
</div>